import axios from "axios";
import qs from "qs";
// 测试
// axios.defaults.baseURL = ''
    //正式
    //axios.defaults.baseURL = 'https://jcgyggfwpt.youyongkj.com'

//post请求头
// axios.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8";
//允许跨域携带cookie信息
axios.defaults.withCredentials = true;
//设置超时
axios.defaults.timeout = 600000;

axios.interceptors.request.use(
    config => {
        if (localStorage.getItem('token')) {
            config.headers.Authorization = 'Bearer ' + localStorage.getItem('token');
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(
    response => {
        if (response.status == 200) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    error => {

        // alert(JSON.stringify(error), '请求异常', {
        //     confirmButtonText: '确定',
        //     callback: (action) => {
        //         console.log(action)
        //     }
        // });
    }
);
export default {
    /**
     * @param {String} url 
     * @param {Object} data 
     * @returns Promise
     */
    post(url, data) {
        return new Promise((resolve, reject) => {
            axios({
				method: 'post',
				url,
				data: data,
			})
			.then(res => {
				let resdata = res.data==undefined?res:res.data
				resolve(resdata)
			})
            .catch(err => {
                reject(err)
            });
        })
    },

    get(url, data) {
        return new Promise((resolve, reject) => {
            axios({
                    method: 'get',
                    url,
                    params: data,
                })
                .then(res => {
					let resdata = res.data==undefined?res:res.data
                    resolve(resdata)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
};
